import { mapValues } from "shared-utils";

import {
  kycFormFieldsMap,
  kycManualFormFieldsMap,
  kycPersonFieldsMap,
  kycPersonFieldsMapFunctions,
  prepAddress,
} from "..";
import type { KYCCustomerAppSchema } from "../api-types/company_data_schemas";
import type { AssociatedPersonStaffAppSchema } from "../api-types/staff_app_schemas";

export const getCompanyData = (data, isManualCompanyEntry) => {
  const { company_data } = mapValues<KYCCustomerAppSchema>({
    data,
    valuesMap: isManualCompanyEntry ? kycManualFormFieldsMap : kycFormFieldsMap,
    direction: "out",
  });
  company_data.registered_address = prepAddress(company_data, "registered_address");
  company_data.operating_address = company_data.is_operating_address_same_as_registered_address
    ? null
    : prepAddress(company_data, "operating_address");
  const rawDate = company_data.jurisdiction_specific_data?.date_of_incorporation;
  if (typeof rawDate === "string" && rawDate && company_data.jurisdiction_specific_data) {
    const parts = rawDate.split("-");
    if (parts.length === 3) {
      const [year, month, day] = parts;
      company_data.jurisdiction_specific_data.date_of_incorporation = `${year}-${month.padStart(2, "0")}-${day.padStart(
        2,
        "0"
      )}`;
    }
  }
  return company_data;
};

export const getPersonData = (data) => {
  return mapValues<AssociatedPersonStaffAppSchema>({
    data,
    valuesMap: kycPersonFieldsMap,
    direction: "out",
    mapFunctions: kycPersonFieldsMapFunctions,
  });
};
